import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api, getErrorMessage } from "@/lib/api";
import AuthShell from "./AuthShell";
import { toast } from "sonner";

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe mis à jour.");
      nav("/login");
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Nouveau mot de passe">
      <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
        <label className="block">
          <span className="block text-[11px] uppercase tracking-[0.15em] text-zinc-500 font-mono mb-2">
            Nouveau mot de passe
          </span>
          <input
            data-testid="reset-password"
            type="password"
            required
            minLength={8}
            maxLength={128}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-white border border-zinc-300 px-4 py-2.5 text-sm focus:border-[#002FA7] focus:ring-1 focus:ring-[#002FA7] outline-none"
          />
        </label>
        <button
          data-testid="reset-submit"
          disabled={loading}
          className="w-full bg-[#002FA7] hover:bg-[#00227A] text-white text-sm font-medium py-3 transition-colors disabled:opacity-50"
        >
          {loading ? "Mise à jour..." : "Valider"}
        </button>
        <Link to="/login" className="inline-block text-xs text-zinc-600 hover:text-[#002FA7]">
          ← Retour à la connexion
        </Link>
      </form>
    </AuthShell>
  );
}
